import React from 'react'
import { Modal, Button, Checkbox, Feed, Image, Divider } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import Labels from './../../../../common/Labels'

import { Form } from 'formsy-semantic-ui-react';
import 'react-quill/dist/quill.snow.css'; // ES6
import momentDate from './../../../../../helpers/momentDate'
import ImageAvater from '../../../../drive/Components/ImageAvater';
import TextEditor from '../../../../common/TextEditor';
import momentTime from '../../../../../helpers/momentTime';


var moment = require('moment');
class IssurResolvedModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resolveComments: '',
            MarkAsCompleteFlag: false
        }

    }

    close = () => {
        this.setState({ MarkAsCompleteFlag: false, resolveComments: '' });
        this.props.IssueResolvedModal(false);
    }

    issueResolvedComments = async () => {
        this.props.selectedActivityData.issueFlag = false;

        const today = new Date();
        const todayStr = `${today.getFullYear}-${today.getMonth + 1}-${today.getDate}`;
        const todaysStartTime = moment(`${todayStr} 00:00`, "YYYY-MM-DD hh:mm");
        const todayEndTime = moment(`${todayStr} 23:59`, "YYYY-MM-DD hh:mm");

        const activityStartDate = moment(this.props.selectedActivityData.expectedStartDate, "YYYY-MM-DD hh:mm");
        const activityEndDate = moment(this.props.selectedActivityData.endDate, "YYYY-MM-DD hh:mm");

        if (activityStartDate < todaysStartTime) {
            this.props.selectedActivityData.isDelayedToStart = true;
        }
        else if (activityEndDate < todayEndTime) {
            this.props.selectedActivityData.isDelayedToEnd = true;
        }


        if (this.state.MarkAsCompleteFlag) {
            this.props.selectedActivityData.completeActivitystring = "MarkAsComplete";
            this.props.selectedActivityData.oldRunStatus = this.props.selectedActivityData.runStatus;
            this.props.selectedActivityData.runStatus = 2;
            this.props.selectedActivityData.progress = 100;
        } else {
            this.props.selectedActivityData.completeActivitystring = "";
        }
        this.props.selectedActivityData.string = "IssueResolved"
        this.props.selectedActivityData.issueLogComments[0].resolveComment = this.state.resolveComments;
        this.props.selectedActivityData.issueLogComments[0].issueResolveDate = moment();
        this.props.selectedActivityData.issueLogComments[0].issueStatus = 1;
        if (this.props.activeTab === "myactivities") {
            await dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            this.props.selectedActivityData.completeActivitystring = "";
        }
        else {
            await dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            this.props.selectedActivityData.completeActivitystring = "";
        }
        this.close();

    }
    markAsCompleteActivity = (event, data) => {
        this.setState({ MarkAsCompleteFlag: data.checked });
    }

    updateText = (data, name) => {
        if (name === "Comment") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ resolveComments: '' })
            } else {
                this.setState({ resolveComments: data })
            }
        }
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                className="ResolvedModalCard basicModal"
                open={this.props.IssueResolvedModalFlag}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header><span className="clr-blue" >Resolve Issue</span> </Modal.Header>
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="issue"
                    id="issueid"
                    onValidSubmit={() => { this.issueResolvedComments() }}
                >
                    <Modal.Content scrolling className="pad_20">
                        <span className="head">{this.props.selectedActivityData.name}</span>

                        <Feed className={`issueMessage ${this.props.resolvedModal} bg-light-blue`} >
                            <Feed.Event className="pad_10">
                                <ImageAvater user={this.props.selectedActivityData.issueLogComments[0].accountUserId} />
                                <Feed.Content>
                                    <Feed.Summary>
                                        {this.props.selectedActivityData.issueLogComments[0].accountUserId.firstName} {this.props.selectedActivityData.issueLogComments[0].accountUserId.lastName}
                                        <span className="pull-right">
                                            {momentDate(this.props.selectedActivityData.issueLogComments[0].issueDate)}
                                        </span>
                                    </Feed.Summary>
                                    <Feed.Date>

                                        <span>Created an issue</span>
                                        <span className="pull-right" style={{ textAlign: "right" }}>
                                            {momentTime(this.props.selectedActivityData.issueLogComments[0].issueDate)}
                                        </span></Feed.Date>
                                </Feed.Content>
                            </Feed.Event>
                            <Divider className="mar_0" />
                            <div className="pad_10">
                                <Labels
                                    name="Why this is an issue?"
                                    text={this.props.selectedActivityData.issueLogComments[0].issue}
                                    htmlView={true} />
                                <Labels
                                    name="Recommended Actions"
                                    text={this.props.selectedActivityData.issueLogComments[0].recommendedActions ? this.props.selectedActivityData.issueLogComments[0].recommendedActions : 'None'}
                                    htmlView={true} />
                            </div>
                        </Feed>

                        <TextEditor
                            name="Comment"
                            text={this.state.resolveComments}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />

                        {this.props.selectedActivityData.onHoldFlag || this.props.selectedActivityData.runStatus === -1 ? " " :
                            <div style={{ textAlign: 'left' }}>
                                <Checkbox className='diamond-location' checked={this.state.MarkAsCompleteFlag}
                                    onChange={(event, data) => this.markAsCompleteActivity(event, data)} />
                                <span style={{ "marginLeft": "12px" }}>Mark as Completed</span>
                            </div>
                        }
                        <br />

                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy" >
                        <Button content='Cancel' className="button-cancel" onClick={this.close} />
                        <Button type="submit" content='Resolve' disabled={!this.state.resolveComments || this.state.resolveComments && this.state.resolveComments.length === 0} className="button-submit" />
                    </Modal.Actions>
                </Form >
            </Modal>


        )
    }
}



export default IssurResolvedModal;